"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ImageBase = _interopRequireDefault(require("./ImageBase.js"));

var _ImageState = _interopRequireDefault(require("./ImageState.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/ImageCanvas
 */


/**
 * A function that is called to trigger asynchronous canvas drawing.  It is
 * called with a "done" callback that should be called when drawing is done.
 * If any error occurs during drawing, the "done" callback should be called with
 * that error.
 *
 * @typedef {function(function(Error=): void): void} Loader
 */
var ImageCanvas =
/** @class */
function (_super) {
  __extends(ImageCanvas, _super);
  /**
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {HTMLCanvasElement} canvas Canvas.
   * @param {Loader} [opt_loader] Optional loader function to
   *     support asynchronous canvas drawing.
   */


  function ImageCanvas(extent, resolution, pixelRatio, canvas, opt_loader) {
    var _this = this;

    var state = opt_loader !== undefined ? _ImageState["default"].IDLE : _ImageState["default"].LOADED;
    _this = _super.call(this, extent, resolution, pixelRatio, state) || this;
    /**
     * Optional canvas loader function.
     * @type {?Loader}
     * @private
     */

    _this.loader_ = opt_loader !== undefined ? opt_loader : null;
    /**
     * @private
     * @type {HTMLCanvasElement}
     */

    _this.canvas_ = canvas;
    /**
     * @private
     * @type {?Error}
     */

    _this.error_ = null;
    return _this;
  }
  /**
   * Get any error associated with asynchronous rendering.
   * @return {?Error} Any error that occurred during rendering.
   */


  ImageCanvas.prototype.getError = function () {
    return this.error_;
  };
  /**
   * Handle async drawing complete.
   * @param {Error} [err] Any error during drawing.
   * @private
   */


  ImageCanvas.prototype.handleLoad_ = function (err) {
    if (err) {
      this.error_ = err;
      this.state = _ImageState["default"].ERROR;
    } else {
      this.state = _ImageState["default"].LOADED;
    }

    this.changed();
  };
  /**
   * Load not yet loaded URI.
   */


  ImageCanvas.prototype.load = function () {
    if (this.state == _ImageState["default"].IDLE) {
      this.state = _ImageState["default"].LOADING;
      this.changed();
      this.loader_(this.handleLoad_.bind(this));
    }
  };
  /**
   * @return {HTMLCanvasElement} Canvas element.
   */


  ImageCanvas.prototype.getImage = function () {
    return this.canvas_;
  };

  return ImageCanvas;
}(_ImageBase["default"]);

var _default = ImageCanvas;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUdBOztBQUNBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBSkE7Ozs7O0FBTUE7Ozs7Ozs7O0FBU0E7QUFBQTtBQUFBO0VBQTBCQTtFQUN4Qjs7Ozs7Ozs7OztFQVFBLHFCQUFZQyxNQUFaLEVBQW9CQyxVQUFwQixFQUFnQ0MsVUFBaEMsRUFBNENDLE1BQTVDLEVBQW9EQyxVQUFwRCxFQUE4RDtJQUE5RDs7SUFDRSxJQUFNQyxLQUFLLEdBQ1RELFVBQVUsS0FBS0UsU0FBZixHQUEyQkMsdUJBQVdDLElBQXRDLEdBQTZDRCx1QkFBV0UsTUFEMUQ7WUFHQUMsa0JBQU1WLE1BQU4sRUFBY0MsVUFBZCxFQUEwQkMsVUFBMUIsRUFBc0NHLEtBQXRDLEtBQTRDO0lBRTVDOzs7Ozs7SUFLQU0sS0FBSSxDQUFDQyxPQUFMLEdBQWVSLFVBQVUsS0FBS0UsU0FBZixHQUEyQkYsVUFBM0IsR0FBd0MsSUFBdkQ7SUFFQTs7Ozs7SUFJQU8sS0FBSSxDQUFDRSxPQUFMLEdBQWVWLE1BQWY7SUFFQTs7Ozs7SUFJQVEsS0FBSSxDQUFDRyxNQUFMLEdBQWMsSUFBZDs7RUFDRDtFQUVEOzs7Ozs7RUFJQUM7SUFDRSxPQUFPLEtBQUtELE1BQVo7RUFDRCxDQUZEO0VBSUE7Ozs7Ozs7RUFLQUMsOENBQVlDLEdBQVosRUFBZTtJQUNiLElBQUlBLEdBQUosRUFBUztNQUNQLEtBQUtGLE1BQUwsR0FBY0UsR0FBZDtNQUNBLEtBQUtYLEtBQUwsR0FBYUUsdUJBQVdVLEtBQXhCO0lBQ0QsQ0FIRCxNQUdPO01BQ0wsS0FBS1osS0FBTCxHQUFhRSx1QkFBV0UsTUFBeEI7SUFDRDs7SUFDRCxLQUFLUyxPQUFMO0VBQ0QsQ0FSRDtFQVVBOzs7OztFQUdBSDtJQUNFLElBQUksS0FBS1YsS0FBTCxJQUFjRSx1QkFBV0MsSUFBN0IsRUFBbUM7TUFDakMsS0FBS0gsS0FBTCxHQUFhRSx1QkFBV1ksT0FBeEI7TUFDQSxLQUFLRCxPQUFMO01BQ0EsS0FBS04sT0FBTCxDQUFhLEtBQUtRLFdBQUwsQ0FBaUJDLElBQWpCLENBQXNCLElBQXRCLENBQWI7SUFDRDtFQUNGLENBTkQ7RUFRQTs7Ozs7RUFHQU47SUFDRSxPQUFPLEtBQUtGLE9BQVo7RUFDRCxDQUZEOztFQUdGO0FBQUMsQ0EzRUQsQ0FBMEJTLHFCQUExQjs7ZUE2RWVQLFciLCJuYW1lcyI6WyJfX2V4dGVuZHMiLCJleHRlbnQiLCJyZXNvbHV0aW9uIiwicGl4ZWxSYXRpbyIsImNhbnZhcyIsIm9wdF9sb2FkZXIiLCJzdGF0ZSIsInVuZGVmaW5lZCIsIkltYWdlU3RhdGUiLCJJRExFIiwiTE9BREVEIiwiX3N1cGVyIiwiX3RoaXMiLCJsb2FkZXJfIiwiY2FudmFzXyIsImVycm9yXyIsIkltYWdlQ2FudmFzIiwiZXJyIiwiRVJST1IiLCJjaGFuZ2VkIiwiTE9BRElORyIsImhhbmRsZUxvYWRfIiwiYmluZCIsIkltYWdlQmFzZSJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzcmMvSW1hZ2VDYW52YXMuanMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=